import { render, staticRenderFns } from "./TodoLeftSidebar.vue?vue&type=template&id=54b23752&scoped=true&"
import script from "./TodoLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoLeftSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoLeftSidebar.vue?vue&type=style&index=1&id=54b23752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b23752",
  null
  
)

export default component.exports